module.exports = __webpack_public_path__ + "static/media/LOGO.8e1f5de1.png";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Login/img/LOGO.png
// module id = 1538
// module chunks = 0